import $ from 'jquery';
export default function edvGridModule() {
    $('.edv-grid-element').on('click', function() {
        let url = $(this).find('a.edv-grid-element-link').attr('href');
        if (url) {
            window.location.href = url;
        }
    });
}